


















































































































import {Component, Prop} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {Tabs} from 'wings-ui-components';
import TemplatesFilter from '@/components/Templates/TemplatesFilter.vue';
import {TemplateItem} from "@/store/settings/templates/types";
import {MsgTransports} from '@/store/types';
import PartnersFilter from "@/components/Settings/Partners/PartnersFilter.vue";

@Component({components: {PartnersFilter, Tabs, TemplatesFilter}})
  export default class Templates extends BaseItemsPage<TemplateItem> {
    @Prop() transport!: MsgTransports;

    @Getter("templates") templateResponse: any;
    @Getter("managementTemplates") managementTemplatesList: any;

    @Action("getTransportsMultichannel") actionGetTransportsMultichannel: any;

    private is_show_filter = false;
    private emailTransport: MsgTransports = MsgTransports.EMAIL;
    private mailNotifyTransport: MsgTransports = MsgTransports.MAILNOTIFY;
    private callTransport: MsgTransports = MsgTransports.CALL

    currentSort= "id";
    currentSortOrder= "desc";

    tableFields = [
      'id',
      'name',
      'partner',
      'partner_user',
      'mn_template_id',
      'priority',
      'active',
      'message',
      'content',
      'subject',
      'vk_message',
      'ok_message',
    ];

    getData(): any {
      return this.templateResponse;
    }

    created() {
      // this.actionGetTransportsMultichannel({transport: this.transport});
    }

    getMailNotifyTemplateName(template_id: number) {
      return this.managementTemplatesList.find((template: any) => template.id === template_id)?.tmpl
    }
  }
